import { jsx as _jsx } from "react/jsx-runtime";
import FormSelector from './FormSelector';
import LoadingBlock from '../Common/LoadingBlock';
import { __ } from '@wordpress/i18n';
import useForms from './hooks/useForms';
import useCreateFormFromTemplate from './hooks/useCreateFormFromTemplate';
import { isDefaultForm } from '../../constants/defaultFormOptions';
import ErrorHandler from '../Common/ErrorHandler';
export default function FormSelect({ formId, formName, handleChange, origin = 'gutenberg', }) {
    const { search, formApiError, reset } = useForms();
    const { createFormByTemplate, reset: createReset, isCreating, hasError, formApiError: createApiError, } = useCreateFormFromTemplate(origin);
    const value = formId && formName
        ? {
            label: formName,
            value: formId,
        }
        : null;
    const handleLocalChange = (option) => {
        if (isDefaultForm(option.value)) {
            createFormByTemplate(option.value).then(({ guid, name }) => {
                handleChange({
                    value: guid,
                    label: name,
                });
            });
        }
        else {
            handleChange(option);
        }
    };
    return isCreating ? (_jsx(LoadingBlock, {})) : formApiError || createApiError ? (_jsx(ErrorHandler, { status: formApiError ? formApiError.status : createApiError.status, resetErrorState: () => {
            if (hasError) {
                createReset();
            }
            else {
                reset();
            }
        }, errorInfo: {
            header: __('There was a problem retrieving your forms', 'leadin'),
            message: __('Please refresh your forms or try again in a few minutes', 'leadin'),
            action: __('Refresh forms', 'leadin'),
        } })) : (_jsx(FormSelector, { loadOptions: search, onChange: (option) => handleLocalChange(option), value: value }));
}
